
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/sfmc",
      function () {
        return require("private-next-pages/ai-decisioning/sfmc.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/sfmc"])
      });
    }
  